// constantes
const initialState = {
  msgList: [],
};

//types
const SET_CONVERSATION = "SET_CONVERSATION";
const SET_CLOSE_CONVERSATION = "SET_CLOSE_CONVERSATION";

//Reducer
export default function conversationState(state = initialState, action) {
  switch (action.type) {
    case SET_CONVERSATION:
      const lastIndex = state.msgList.length - 1;
      const lastData = state.msgList[lastIndex];
      if (
        state.msgList.length > 0 &&
        lastData.hour === action.msg.hour &&
        lastData.position === action.msg.position &&
        lastData.messageType === 'image' && 
        action.msg.messageType === 'image'
      ) {
        return {
          ...state,
          msgList:Object.values({
            ...state.msgList,
            [lastIndex]:{
              ...state.msgList[lastIndex],
              msg: state.msgList[lastIndex].msg + '^^' + action.msg.msg ,
            }
          }),
        };
      }
      return {
        ...state,
        msgList: [
          ...state.msgList,
          {
            msgId: state.msgList.length + 1,
            msg: action.msg.msg,
            position: action.msg.position,
            hour: action.msg.hour,
            messageType: action.msg.messageType,
          },
        ],
      };
    case SET_CLOSE_CONVERSATION:
      return {
        ...state,
        msgList: [],
      };
    default:
      return state;
  }
}

//Actions
export const setMessage = (msg) => ({ type: SET_CONVERSATION, msg });
export const setCloseConversation = () => ({ type: SET_CLOSE_CONVERSATION });
//selector
export const getMsgList = (state) => state.conversation.msgList;
